var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EB40AF05-B8E0-4EF2-98FA-42DB3639C5A2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,18.0049 C18,18.5519 17.552,18.9999 17.005,18.9999 L2.995,18.9999 C2.448,18.9999 2,18.5519 2,18.0049 L2,14.9999 L2,12.9999 L2,6.9999 L2,4.9999 L2,1.9949 C2,1.4479 2.448,0.9999 2.995,0.9999 L17.005,0.9999 C17.552,0.9999 18,1.4479 18,1.9949 L18,18.0049 Z M17,-0.0001 C18.1,-0.0001 19,0.9009 19,2.0009 L19,17.9999 C19,19.0999 18.1,19.9999 17,19.9999 L3,19.9999 C1.9,19.9999 1,19.0999 1,17.9999 L1,14.9999 C0.45,14.9999 0,14.5499 0,13.9999 C0,13.4499 0.45,12.9999 1,12.9999 L1,6.9999 C0.45,6.9999 0,6.5499 0,5.9999 C0,5.4499 0.45,4.9999 1,4.9999 L1,2.0009 C1,0.9009 1.9,-0.0001 3,-0.0001 L17,-0.0001 Z M16.005,2 L3.995,2 C3.448,2 3,2.448 3,2.995 L3,5 C3.55,5 4,5.45 4,6 C4,6.55 3.55,7 3,7 L3,13 C3.55,13 4,13.45 4,14 C4,14.55 3.55,15 3,15 L3,17.005 C3,17.552 3.448,18 3.995,18 L16.005,18 C16.552,18 17,17.552 17,17.005 L17,2.995 C17,2.448 16.552,2 16.005,2 Z M12,10 C12,10.19 11.965,10.37 11.915,10.544 C11.938,10.553 11.961,10.555 11.982,10.567 L12.848,11.067 C13.087,11.205 13.169,11.511 13.031,11.75 C12.938,11.91 12.771,12 12.598,12 C12.513,12 12.427,11.979 12.348,11.933 L11.482,11.433 C11.462,11.422 11.451,11.403 11.433,11.39 C11.179,11.652 10.852,11.841 10.486,11.933 C10.49,11.956 10.5,11.976 10.5,12 L10.5,13 C10.5,13.276 10.276,13.5 10,13.5 C9.724,13.5 9.5,13.276 9.5,13 L9.5,12 C9.5,11.976 9.51,11.956 9.514,11.933 C9.148,11.841 8.822,11.652 8.567,11.39 C8.549,11.403 8.538,11.422 8.518,11.433 L7.652,11.933 C7.573,11.979 7.487,12 7.402,12 C7.229,12 7.062,11.91 6.969,11.75 C6.831,11.511 6.913,11.205 7.152,11.067 L8.018,10.567 C8.039,10.555 8.062,10.553 8.085,10.544 C8.035,10.37 8,10.19 8,10 C8,9.809 8.036,9.627 8.086,9.451 C8.064,9.442 8.04,9.445 8.018,9.433 L7.152,8.933 C6.913,8.795 6.831,8.489 6.969,8.25 C7.107,8.011 7.413,7.929 7.652,8.067 L8.518,8.567 C8.538,8.578 8.549,8.597 8.567,8.61 C8.822,8.348 9.148,8.159 9.514,8.067 C9.51,8.044 9.5,8.024 9.5,8 L9.5,7 C9.5,6.724 9.724,6.5 10,6.5 C10.276,6.5 10.5,6.724 10.5,7 L10.5,8 C10.5,8.024 10.49,8.044 10.486,8.067 C10.852,8.159 11.179,8.348 11.433,8.61 C11.451,8.597 11.462,8.578 11.482,8.567 L12.348,8.067 C12.587,7.929 12.893,8.011 13.031,8.25 C13.169,8.489 13.087,8.795 12.848,8.933 L11.982,9.433 C11.96,9.445 11.936,9.442 11.914,9.451 C11.964,9.627 12,9.809 12,10 Z M10,9 C9.448,9 9,9.448 9,10 C9,10.552 9.448,11 10,11 C10.552,11 11,10.552 11,10 C11,9.448 10.552,9 10,9 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "14-vault",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.0c-UCAP-AdvisorCenter-Vault-FolderCreated",
    transform: "translate(-260.000000, -112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.0-UCAP-AdvisorCenter-Vault"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(260.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/networth"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_vault",
    fill: "#8A8888",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#8A8888"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVault);
export default __webpack_public_path__ + "static/media/ic_vault.0a7d96c9b2c7789b8d5b447806349c6c.svg";
export { ForwardRef as ReactComponent };